module.exports = __webpack_public_path__ + "../resources/images/illustration_mention-78a75cfe7e57f79cdb738829385f1df6.svg";